import { Bank } from 'data/Payments/BankTransfer/types'
import fetchApi from 'utils/fetchApi'
import { getApiUrl } from 'utils/urlBuilder'

export const getBanks = () =>
  fetchApi<Array<Bank>>({
    auth: true,
    method: 'GET',
    url: getApiUrl('nabu-gateway/payments/banktransfer')
  })

export const getBank = (bankId: string) =>
  fetchApi<Bank>({
    auth: true,
    method: 'GET',
    url: getApiUrl(`nabu-gateway/payments/banktransfer/${bankId}`)
  })

type CreateBankPayload = {
  attributes?: {
    redirect_uri: string
    supportedPartners: string[]
  }
  currency: string
}
export const createBankAccountLink = (body: CreateBankPayload) =>
  fetchApi<Bank>({
    auth: true,
    body,
    method: 'POST',
    url: getApiUrl('nabu-gateway/payments/banktransfer')
  })

export const fetchBankLinkTokenForRefresh = (pmId: string, attributes: object, callback: string) =>
  fetchApi<Bank>({
    auth: true,
    body: {
      attributes: {
        ...attributes,
        callback
      }
    },
    method: 'POST',
    url: getApiUrl(`nabu-gateway/payments/banktransfer/${pmId}/refresh`)
  })

export const updateBankAccountLink = (pmId: string, attributes: object, callback: string) =>
  fetchApi<Bank>({
    auth: true,
    body: {
      attributes: {
        ...attributes,
        callback
      }
    },
    method: 'POST',
    url: getApiUrl(`nabu-gateway/payments/banktransfer/${pmId}/update`)
  })

export const createPayment = (
  orderId: string,
  amountMinor: string,
  currency: string,
  pmId: string,
  callback: string
) =>
  fetchApi<void>({
    auth: true,
    body: {
      amountMinor,
      attributes: { callback },
      currency,
      orderId,
      product: 'MERCURY'
    },
    method: 'POST',
    url: getApiUrl(`nabu-gateway/payments/banktransfer/${pmId}/payment`)
  })

export const blockBank = (bankId: string) =>
  fetchApi<void>({
    auth: true,
    method: 'DELETE',
    url: getApiUrl(`nabu-gateway/payments/banktransfer/${bankId}`)
  })
